module.exports = __webpack_public_path__ + "fonts/Inter-SemiBold.0cdf3c6a.woff";